var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAddressFilterIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4964 9.27286V9.27286C22.9541 10.7306 23.7731 12.7078 23.7731 14.7694C23.7731 16.831 22.9541 18.8081 21.4964 20.2659V20.2659L17.2951 24.4671C16.5797 25.1825 15.4199 25.1825 14.7046 24.4671L10.5033 20.2658C9.04553 18.8081 8.22656 16.8309 8.22656 14.7693C8.22656 12.7077 9.04553 10.7306 10.5033 9.27282V9.27282C11.9611 7.81505 13.9382 6.99609 15.9998 6.99609C18.0614 6.99609 20.0386 7.81508 21.4964 9.27286Z",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0701 16.3821C12.3065 15.6185 12.3065 14.3805 13.07 13.617L14.6166 12.0704C15.3802 11.3068 16.6182 11.3068 17.3817 12.0704L18.9283 13.617C19.6919 14.3805 19.6919 15.6185 18.9283 16.3821L17.3817 17.9286C16.6182 18.6922 15.3802 18.6922 14.6166 17.9286L13.0701 16.3821Z",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddressFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AddressFilterIcon.cc7ab3f0.svg";
export { ForwardRef as ReactComponent };